import GamesScreenContent from "../../components/others/games/GamesScreenContent";
import {Helmet} from "react-helmet";
import {buildHelmetTitle} from "../../helpers/SeoHelper";
import SystemAppScreenHeader from "../../components/headers/SystemAppScreenHeader";
import {kSystemIcons} from "../../constants/icons";
import {useState} from "react";
import GamesScreenInfoDialog from "../../components/dialogs/games/GamesScreenInfoDialog";

export default function GamesScreen() {
    // Used in index.js to handle Games related content

    // PROPERTIES
    const [isInfoModalOpen, setIsInfoModalOpen] = useState(false)

    // BUILD
    return (
        <div className={"w-full h-[100svh] bg-backgroundLight3 flex justify-start items-center"}>
            {/** META */}
            <Helmet>
                <title>{buildHelmetTitle('Ummia - Jeux')}</title>
                <meta name="description"
                      content="Jeux pédagogiques mathématiques pour développer des réflexes quasi instinctifs." />
            </Helmet>
            {/** MODAL */}
            <GamesScreenInfoDialog open={isInfoModalOpen}
                                   handleClose={processModalClosing} />
            {/** CONTENT */}
            <div className={"animate-appear grow w-full h-full flex flex-col justify-start items-center min-h-0"}>
                <div className={"w-full p-[16px]"}>
                    <SystemAppScreenHeader title={"Jeux éducatifs"}
                                           icon={kSystemIcons.games}
                                           onInfoClick={processModalOpening}
                                           isBrevetDisplay={false} />
                </div>
                <GamesScreenContent />
            </div>
        </div>
    );

    // METHODS
    // ---- LOGIC : Open modal process
    function processModalOpening() {
        if (!isInfoModalOpen) {
            setIsInfoModalOpen(true);
        }
    }

    // ---- LOGIC : Close modal process
    function processModalClosing() {
        if (isInfoModalOpen) {
            setIsInfoModalOpen(false)
        }
    }
}